import React, { useState, useEffect } from 'react';
import { Box, Typography, Container, Paper, Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const testimonials = [
  {
    name: 'Rajesh Kulkarni',
    role: 'Shop Owner, Pune',
    text: 'CCTV Partner installed 8 cameras in my showroom within a single day. Quality work, clean wiring, and the team was very professional. Highly recommended!',
    initials: 'RK',
    color: '#1e90d4',
  },
  {
    name: 'Sneha Deshmukh',
    role: 'Home Owner, Kothrud',
    text: 'I was worried about the installation process but the team made it so easy. They explained everything clearly and my home feels so much safer now.',
    initials: 'SD',
    color: '#2ecc71',
  },
  {
    name: 'Amit Sharma',
    role: 'Factory Manager, PCMC',
    text: 'We have an AMC with them for our entire factory. Response time is excellent and they are always available when we need support. Very reliable company.',
    initials: 'AS',
    color: '#f0c040',
  },
  {
    name: 'Pooja Joshi',
    role: 'Restaurant Owner, Baner',
    text: 'The mobile app access is fantastic. I can monitor my restaurant from anywhere. Great service and very reasonable pricing compared to others.',
    initials: 'PJ',
    color: '#9b59b6',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{
      py: 12,
      background: 'linear-gradient(135deg, #081e35, #0a2540)',
    }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography sx={{ fontSize: '0.8rem', letterSpacing: '3px', color: '#1e90d4', textTransform: 'uppercase', mb: 2, fontWeight: 600 }}>
            Client Reviews
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '2.2rem', md: '3rem' }, color: '#e8f0fe', mb: 2 }}>
            What Our <Box component="span" sx={{ color: '#1e90d4' }}>Clients Say</Box>
          </Typography>
          <Box sx={{ width: 60, height: 3, background: 'linear-gradient(90deg, #1e90d4, transparent)', mx: 'auto', borderRadius: 2 }} />
        </Box>

        <Box sx={{ maxWidth: 800, mx: 'auto' }}>
          <Paper sx={{
            p: { xs: 4, md: 6 },
            background: 'rgba(13,40,71,0.7)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(30,144,212,0.2)',
            borderRadius: '20px',
            position: 'relative', overflow: 'hidden',
            boxShadow: '0 24px 60px rgba(0,0,0,0.4)',
            minHeight: 260,
            transition: 'all 0.4s ease',
          }}>
            <FormatQuoteIcon sx={{
              position: 'absolute', top: 20, right: 30,
              fontSize: 80, color: 'rgba(30,144,212,0.08)',
            }} />

            <Box sx={{ display: 'flex', gap: 0.5, mb: 3 }}>
              {[...Array(5)].map((_, i) => (
                <StarIcon key={i} sx={{ color: '#f0c040', fontSize: 20 }} />
              ))}
            </Box>

            <Typography sx={{
              color: '#c8ddf0', fontSize: '1.1rem', lineHeight: 1.8,
              mb: 4, fontStyle: 'italic',
              transition: 'opacity 0.3s',
            }}>
              "{testimonials[active].text}"
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{
                background: `${testimonials[active].color}25`,
                border: `2px solid ${testimonials[active].color}50`,
                color: testimonials[active].color,
                fontWeight: 700, width: 50, height: 50,
              }}>
                {testimonials[active].initials}
              </Avatar>
              <Box>
                <Typography sx={{ color: '#e8f0fe', fontWeight: 600 }}>
                  {testimonials[active].name}
                </Typography>
                <Typography sx={{ color: '#8fb3d9', fontSize: '0.85rem' }}>
                  {testimonials[active].role}
                </Typography>
              </Box>
            </Box>
          </Paper>

          {/* Dots */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, mt: 4 }}>
            {testimonials.map((_, i) => (
              <Box
                key={i}
                onClick={() => setActive(i)}
                sx={{
                  width: i === active ? 24 : 8,
                  height: 8, borderRadius: 4,
                  background: i === active ? '#1e90d4' : 'rgba(30,144,212,0.25)',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                }}
              />
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
